'use strict';
angular
    .module('MW.InsDashboard.WidgetController', [
        'MW.Framework.CoreCommon',
        'MW.InsDashboard.ChartService',
        'MW.InsDashboard.InsWidgetConfigService',
        'MW.InsDashboard.ChartDataService',
        'MW.Framework.Breadcrumb',
        'MW.Dashboard.DashboardStateService',
        'MW.InsDashboard.NavBarStateChangeService',
        'MW.Dashboard.ShareableDashboardsAdditionalData'
    ])
    .controller("WidgetController", [
        '$rootScope',
        '$scope',
        'CoreCommon',
        'ChartService',
        'InsWidgetConfigService',
        'ChartDataService',
        'CoreChartObject',
        'Breadcrumb',
        '$location',
        '$routeParams',
        '$filter',
        'DashboardStateService',
        'NavBarStateChangeService',
        'ShareableDashboardsAdditionalData',
        'Base64Service',
        function WidgetController($rootScope, $scope, CoreCommon, ChartConfigService, InsWidgetConfigService, ChartDataService, CoreChartObject, Breadcrumb, $location, $routeParams, $filter, DashboardStateService, NavBarStateChangeService, ShareableDashboardsAdditionalData, base64Service) {

            NavBarStateChangeService.handleSizeToggleEvent($scope);

            $scope.chartData = null;//chart data for min or max is kept here
            $scope.widgetIsLoading = false;
            $scope.noDataFromServer = false;
            $scope.notConfigured = false;
            $scope.serviceError=false;
            $scope.highchart = true;
            $scope.lastSearchId='';
            $scope.lastSearchDate='';
            $scope.searches = [];
            $scope.inputs = [];
            $scope.request={
                dateFrom: null, dateTo:null,
                brands:[]
            };
            $scope.widgetsValidForMwVisualizations = [
                'volume-widget'
            ];

            $scope.mwVisualization = false;
            $scope.mwGroupedChartData = [];
            $scope.showMwVisualization = false;
            $scope.barChartSettings = null;

            if(!$scope.documentRequest) {
                $scope.documentRequest = {};
            }

            //Table variables
            $scope.showTable = false;
            $scope.tableSettings  = {
                enabled: false,
                data:[],
                summary:[],
                rowTitle:'',
                titleField:'',
                countField:'',
                percentField:'',
                drilldown:false
            };

            $scope.showErrorState = false;

            var widgetConfig = {},
                getDefaultChartTypeFromSettings = function getDefaultChartTypeFromSettings() {
                    return CoreCommon.isUsable($scope.widget.settings.selectedGraphType)?$scope.widget.settings.selectedGraphType.id : $scope.widget.getDefaultChartType().id;
                },
                getLabelFormatFromSettings = function getLabelFormatFromSettings() {
                    return CoreCommon.isUsable($scope.widget.settings.labelFormat) ? $scope.widget.settings.labelFormat[0].id : $scope.widget.availableLabelFormat[0].id;
                },
                getDateBreakoutsFromSettings = function getDateBreakoutsFromSettings() {
                    return CoreCommon.isUsable($scope.widget.settings.dateBreakouts) ? $scope.widget.settings.dateBreakouts[0].id : $scope.widget.availableDateBreakouts[0].id;
                },
                getLabelVisibilityFromSettings = function getLabelVisibilityFromSettings() {
                    return CoreCommon.isUsable($scope.widget.settings.labelVisibility) ? $scope.widget.settings.labelVisibility[0].id : $scope.widget.availableLabelVisibility[0].id;
            };

            $scope.initWidget = function initWidget(settings) {
                widgetConfig = settings;
                $scope.widget.dateQueryStartOverride = $scope.widgetLoadTime;
                $scope.insightsService = settings.insightsService || 'statisticServiceDateHistogram';
                $scope.insightsObject = settings.insightsObject || 'dateHistograms';

                $scope.selectedLabelFormatId = getLabelFormatFromSettings(); // Getting Label Format id from widget.settings

                $scope.labelVisibility = (getLabelVisibilityFromSettings() == 1) ? false : true;  // Getting Data Labels from widget.settings

                if($scope.selectedLabelFormatId == 1) { // Number
                    $scope.percentageMode = false;
                } else if ($scope.selectedLabelFormatId == 2) { // Percentage
                    $scope.percentageMode = true;
                }

                $scope.selectedDateBreakoutsId = getDateBreakoutsFromSettings(); // Getting Date Breakouts Id from widget.settings

                $scope.dateBreakoutsDay = ($scope.selectedDateBreakoutsId === 'DAY')? true : false;
                $scope.dateBreakoutsWeek = ($scope.selectedDateBreakoutsId === 'WEEK')? true : false;
                $scope.dateBreakoutsMonth = ($scope.selectedDateBreakoutsId === 'MONTH')? true : false;
                $scope.dateBreakoutsQuarter = ($scope.selectedDateBreakoutsId === 'QUARTER')? true : false;
                $scope.dateBreakoutsYear = ($scope.selectedDateBreakoutsId === 'YEAR')? true : false;

                if(typeof settings.table != 'undefined'){
                    for(var tableProp in settings.table){
                        $scope.tableSettings[tableProp] = settings.table[tableProp];
                    }
                }

                if($scope.widget.hasRequiredSettings()){
                    $scope.graphType = getDefaultChartTypeFromSettings();
                    //If we come in to this widget with the table set then we also need to set this flag to enable the view
                    //This is implemented because exports directly access the widget this way now. If the user is viewing the widget in table mode
                    //The new report/export view will pass in $scope.widget.settings.selectedGraphType.id
                    $scope.showTable = $scope.graphType == 'table' ? true : false;
                    $scope.fetchData();
                }
            };

            function toogleBarChart() {
                if ($scope.barChartSettings && $scope.graphType === 'column') {
                    $scope.showMwVisualization = !$scope.percentageMode;
                    $scope.mwVisualization = !$scope.percentageMode;

                    if ($scope.percentageMode) {
                        widgetConfig.charts.column = $scope.barChartSettings.barChart;
                    } else {
                        widgetConfig.charts.column = $scope.barChartSettings.groupedColumn;
                    }
                }
            }

            $scope.initSettings = function initSettings(){
                $scope.timezoneOverride = widgetConfig.timezoneOverride;
                InsWidgetConfigService.readyWidgetData($scope);
            };

            $scope.togglePercentage = function togglePercentage(id) {
                var oldMode = $scope.percentageMode,
                    mode;
                $scope.selectedLabelFormatId = id;
                if(id === 1) {
                    mode = false;
                } else if (id === 2) {
                    mode = true;
                }

                $scope.percentageMode = mode;

                if (oldMode !== $scope.percentageMode)
                    $scope.fetchData();
            };


            $scope.toggleGraph = function toggleGraph(graphType) {
                /*
                * Date comparison only supported for spline chart atm
                 */
                if(graphType !== 'spline'){
                    $scope.toggleComparison = angular.copy($scope.widget.settings.dateComparison)
                    $scope.widget.settings.dateComparison = false;
                } else {
                    $scope.widget.settings.dateComparison =  $scope.toggleComparison;
                }

                if(graphType === 'column' && $scope.mwVisualization === true) {
                    $scope.showMwVisualization = true;
                } else {
                    $scope.showMwVisualization = false;
                }

                InsWidgetConfigService.queryRequestSettings.dateStart = $scope.chartDataObject.fromDate;
                InsWidgetConfigService.queryRequestSettings.dateEnd = $scope.chartDataObject.toDate;
                $scope.graphType = graphType;
                $scope.showTable = false;
                resetBreadcrumb();
                $scope.fetchData();
                $scope.initSettings();
            };

            $scope.toggleTable = function toggleTable() {
                InsWidgetConfigService.queryRequestSettings.dateStart = $scope.chartDataObject.fromDate;
                InsWidgetConfigService.queryRequestSettings.dateEnd = $scope.chartDataObject.toDate;
                $scope.graphType = 'table';
                $scope.showTable = true;
                $scope.showMwVisualization = false;
                resetBreadcrumb();
                $scope.fetchData();
            };

            $scope.internalDrillDown = function internalDrilldown(id, date, linkedTo){
                if($scope.isMaximized){
                    var queryParams = {
                        drilled: true
                    };
                    if(id) {
                        queryParams['inputId'] = id;
                    }
                    if(date) {
                        queryParams['date'] = $filter('mwConvertDateToUserTimezone')(date);
                    }
                    if(linkedTo) {
                        queryParams['linkedTo'] = linkedTo;
                    }

                    updateLocationURL(queryParams);
                }
                InsWidgetConfigService.dateGranularityDrilldown(id,date,$scope,linkedTo);
            };

            var updateLocationURL = function updateLocationURL(queryParams) {
                var maxPath,
                    editMode = $routeParams.editMode || false;
                if($location.path().indexOf('/dashboard/index') === 0) {
                    maxPath = '/dashboard/viewer/'+DashboardStateService.getDefaultDashboard()+'/' + $scope.widget.id;
                } else if($routeParams.dashboardId && $routeParams.dashboardId != 'current' && $routeParams.dashboardId != 'new'){
                    maxPath = $location.path();
                } else {
                    maxPath = '/dashboard/'+($location.path().indexOf('builder') === -1?'viewer':'builder')+'/'+(DashboardStateService.currentDashboard._id || 'current') + '/' + $scope.widget.id;
                }

                if(!$routeParams.drilled) {
                    queryParams['drilled'] = true;
                }

                var urlQuery = {
                    editMode:editMode
                };
                for(var prop in queryParams) {
                    urlQuery[prop] = queryParams[prop]
                }

                $location.path(maxPath).search(urlQuery);
            };

            var getRequestParams = function getRequestparams(url) {
                var params = {};
                var searchStr = url.split("?")[1];
                if(searchStr !== undefined) {
                    var paramsStr = searchStr.split("&");
                    for(var key in paramsStr) {
                        params[paramsStr[key].split("=")[0]] = paramsStr[key].split("=")[1];
                    }
                }
                return params;
            };

            $scope.$on('$locationChangeSuccess', function onCoreBreadcrumbLocationChangeSuccess(event, newVal, oldVal) {
                var oldParams = getRequestParams(oldVal),
                    newParams = getRequestParams(newVal),
                    breadcrumbString,
                    breadcrumbArray,
                    displayDate;

                    if(newParams.date) {
                        //correctly parsing the '+' character in encoded date in newParams
                        newParams.date = newParams.date.replace(/(%2B)/g, '+');
                    }

                    if(newParams.inputId) {
                        //correctly parsing the space in inputId in newParams
                        newParams.inputId = newParams.inputId.replace(/(%20)/g, ' ');
                    }

                updateBreadcrumb(newParams.inputId, newParams.date);
                if(oldParams.inputId !== undefined && newParams.inputId === undefined) {
                    // Drilling OUT of a datapoint selection.  In the scenario, we don't have the benefit of
                    // the action triggering a content stream refresh, so we have to trigger it ourselves here.
                    // Calling the drilldown function in this way essentially triggers a reset
                    InsWidgetConfigService.dateGranularityDrilldown(false, undefined, $scope);
                } else if((newParams.inputId !== undefined && oldParams.inputId === undefined) || (newParams.inputId !== undefined && oldParams.inputId !== undefined && ((newParams.inputId !== oldParams.inputId) || (newParams.date !== oldParams.date)))) {
                    // In this case, the user probably used the browser's Forward button to go back to a drilldown.
                    // Since we don't have the benefit of a click trigger, we need to do it manually here
                    InsWidgetConfigService.dateGranularityDrilldown(newParams.inputId, newParams.date, $scope, newParams.linkedTo);
                }

                if (newVal.indexOf('&drilled&') > -1) {
                    if(newParams.date) {
                        displayDate = moment(newParams.date.split('T')[0]);
                        breadcrumbString = $scope.breadcrumbs[$scope.breadcrumbs.length - 1].name;
                        breadcrumbArray = breadcrumbString.split(',');
                        if ($scope.dateBreakoutsMonth) {
                            updateLastBreadcrumb(breadcrumbArray[0] + ', ' + displayDate.format("MMM") + ' ' + displayDate.year());
                        }
                        else if ($scope.dateBreakoutsQuarter) {
                            updateLastBreadcrumb(breadcrumbArray[0] + ', Q' + displayDate.quarter() + ' ' + displayDate.year());
                        }
                        else if ($scope.dateBreakoutsYear) {
                            updateLastBreadcrumb(breadcrumbArray[0] + ', ' + displayDate.year());
                        }
                    }
                }
            });

            $scope.getMwApi = (mwAPI) => {
                $scope.$on('widgetResized', function onChartResize() {
                    mwAPI.redraw();
                });
            }

            $scope.onMwError = () => {
                $scope.showErrorState = true;
            }

            var updateLastBreadcrumb = function updateLastBreadcrumb(lastBreadcrumb) {
                $scope.breadcrumbs[$scope.breadcrumbs.length - 1].name = lastBreadcrumb;
            };

            var updateBreadcrumb = function updateBreadcrumb(inputId, date) {
                var dashboardPath,
                    widgetPath,
                    selectionTitle = '',
                    searchName = '',
                    dashboardMode = $location.path().indexOf('/dashboard/viewer') !== -1 ? '/dashboard/viewer/' : '/dashboard/builder/';

                $scope.breadcrumbs =[];
                $scope.breadcrumbs = [Breadcrumb.build({
                    name: 'Analyze',
                    link: '/analyze/home',
                    isClickable: false
                })];
                dashboardPath = '/dashboard/viewer/' + $scope.dashboard._id;

                // If using weekly granularity but your widget's date range starts in the middle of the week,
                // the breadcrumbs need to be adjusted to show the start of the widget date range instead of the start of the week.
                // We are doing this check here because this code path gets hit when actively performing a drill down OR when using a bookmarked link (which would have had the wrong date due to the behavior described above)
                if (moment(date) < moment($scope.fromDate)) {
                    date = $scope.fromDate;
                }

                if($scope.searches && $scope.searches.length === 1) {
                    selectionTitle += date ? $filter('mwConvertDateToUserTimezone')(date, 'MMM Do') : '';
                } else {
                    if(inputId) {
                        searchName = $scope.inputs.filter(function(search) {
                            return search.id == inputId;
                        })[0];
                        searchName = searchName ? searchName.name : null;
                    }
                    selectionTitle += searchName ? searchName : '';
                    selectionTitle += date ? ', ' + $filter('mwConvertDateToUserTimezone')(date, 'MMM Do') : '';
                }

                $scope.breadcrumbs.push(Breadcrumb.build({name:$scope.dashboard.title, link:dashboardPath }));
                if(selectionTitle === '') {
                   var mypath = '/dashboard/viewer/'+$scope.dashboard._id,
                       subCrumbs = [],
                       myNewPath,
                       subCrumbVal;

                    if($scope.dashboard.containers[0].widgets.length > 1) {
                        Object.keys($scope.dashboard.containers[0].widgets).forEach(function(key){
                            myNewPath = dashboardMode + $scope.dashboard._id + '/' + $scope.dashboard.containers[0].widgets[key].id + '?editMode=false';
                            subCrumbVal = {
                                name: $scope.dashboard.containers[0].widgets[key].title,
                                link: myNewPath,
                                isClickable: function isClickable() { return true; }
                            };

                            subCrumbs.push(subCrumbVal);
                        });
                    }
                    $scope.breadcrumbs.push(Breadcrumb.build({name:$scope.widget.title, subCrumbs:subCrumbs}));
                } else {
                    widgetPath = dashboardMode + $scope.dashboard._id + '/' + $scope.widget.id + '?editMode=false';
                    $scope.breadcrumbs.push(Breadcrumb.build({name:$scope.widget.title, link: widgetPath}));
                    $scope.breadcrumbs.push(Breadcrumb.build({name:selectionTitle}));
                }
            };

            var resetBreadcrumb = function resetBreadcrumb() {
                var maxPath,
                    editMode = $routeParams.editMode || false;
                if($location.path().indexOf('/dashboard/index') === 0) {
                    maxPath = '/dashboard/viewer/'+DashboardStateService.getDefaultDashboard()+'/' + $scope.widget.id;
                } else if($routeParams.dashboardId && $routeParams.dashboardId != 'current' && $routeParams.dashboardId != 'new'){
                    maxPath = $location.path();
                } else {
                    maxPath = '/dashboard/'+($location.path().indexOf('builder') === -1?'viewer':'builder')+'/'+(DashboardStateService.currentDashboard._id || 'current') + '/' + $scope.widget.id;
                }

                var urlQuery = {
                    editMode:editMode
                };

                updateBreadcrumb();
                $location.path(maxPath).search(urlQuery);
            };

            $scope.isDataPending = function isDataPending(){
                if(typeof $scope.chartDataObject !== 'undefined' && $scope.chartDataObject.pendingData === true){
                    return true;
                }else{
                    return false;
                }
            };

            $scope.fetchData = function fetchData() {
                $scope.initSettings();
                toogleBarChart();

                if(!$scope.readyToQuery) {
                    return;
                }

                $scope.chartData = null;
                $scope.widgetIsLoading = true;
                $scope.mwGroupedChartData = [];

                var viewName = 'user';
                if($scope.isReport){
                    viewName = 'report';
                } else if($scope.isMaximized){
                    viewName = 'max';
                }
                var chartBasics = {
                    type: $scope.graphType,
                    view: viewName,
                    percent : $scope.percentageMode,
                    animate:$scope.isReport ? false : InsWidgetConfigService.getChartAnimationStatus($scope.widget.id+$scope.isMaximized),
                    reportType: $scope.reportType
                };

                if($scope.inputs){
                    $scope.chartDataObject.inputs = $scope.inputs;
                    chartBasics.inputs = $scope.inputs;
                } else if($scope.searches){
                    chartBasics.searches = $scope.searches;
                }

                if(typeof widgetConfig.charts[$scope.graphType].customSettings !== 'undefined'){
                    chartBasics = angular.extend(chartBasics, widgetConfig.charts[$scope.graphType].customSettings);
                }

                //set up our chart data object (the first part of this is handled in ins_widget_config_service)
                $scope.chartDataObject.percentageMode = $scope.percentageMode;
                $scope.chartDataObject.dataMap = widgetConfig.charts[$scope.graphType].dataMap;
                $scope.chartDataObject.chartTransformFunction = function () {
                    try {
                        if(widgetConfig && widgetConfig.mwVisualization) {
                            var additionalData = {};
                            /**
                             * Add additional data needed for shareable dashboards to handle grouped column charts
                             */

                            if(Array.isArray(arguments[0])) {
                                additionalData = arguments[0].map(function(element) {
                                    if(DashboardStateService.inputIdsToColorMapping && DashboardStateService.inputIdsToColorMapping.colors) {
                                        var search = element.search;
                                        var encodedSearchId = base64Service.encode(search.id);
                                        var color = DashboardStateService.inputIdsToColorMapping.colors[encodedSearchId];
                                        return Object.assign(search, {
                                            color: color
                                        });
                                    }
                                    return search;
                                });
                            }

                            ShareableDashboardsAdditionalData.addAdditionalData({
                                key: $scope.widget.id,
                                data: additionalData
                            });
                        }
                    } catch(error) {
                        console.error('Error occurred adding additional data for shareable dashboards');
                        console.error(error);
                    }
                    return widgetConfig.charts[$scope.graphType].transform.apply(this, arguments);
                };

                if(widgetConfig.AveValue) {
                    $scope.chartDataObject.AveValue = widgetConfig.AveValue;
                }
                if(widgetConfig.previousDateEnd && widgetConfig.previousDateStart)  {
                    $scope.chartDataObject['previousDateStart'] = widgetConfig.previousDateStart;
                    $scope.chartDataObject['previousDateEnd'] = widgetConfig.previousDateEnd;
                }
                if(widgetConfig.timezoneOverride) {
                    $scope.chartDataObject.timezoneOverride = widgetConfig.timezoneOverride;
                }

                const validForMwVisualization = $scope.widgetsValidForMwVisualizations.includes($scope.widget.type);

                if($scope.graphType == 'table'){
                    $scope.chartDataObject.callback = function tableCallback(chartRequestData){
                        $scope.tableSettings.data = chartRequestData.table;
                        if($scope.chartDataObject.percentageMode){
                            $scope.tableSettings.displayField = $scope.tableSettings.percentField;
                        }else{
                            $scope.tableSettings.displayField = $scope.tableSettings.countField;
                        }
                        $scope.tableSettings.summary = chartRequestData.summary;
                        $scope.widgetIsLoading = false;
                    };
                } else if ($scope.graphType === 'column' && $scope.mwVisualization && validForMwVisualization) {
                    $scope.chartDataObject.callback = function mwGroupedColumnCallback (chartRequestData) {
                        let customSettings = widgetConfig.charts[$scope.graphType].customSettings || {};
                        if (!customSettings || !customSettings.yAxisTitle) {
                            const settings = new CoreChartObject(chartBasics, chartRequestData);
                            customSettings = Object.assign({}, customSettings, { yAxisTitle: settings.yAxis.title.text });
                        }

                        const chartConfig = {
                            view: chartBasics.view,
                            colors: chartRequestData.colors,
                            customSettings: customSettings,
                            drillDown: $scope.internalDrillDown,
                            series: chartRequestData.series,
                            dataLabels: $scope.labelVisibility,
                        };

                        $scope.mwGroupedChartData = chartRequestData.series;
                        $scope.widgetIsLoading = false;
                        $scope.mwGroupedColumnOptions = widgetConfig.charts[$scope.graphType].chart(chartConfig);
                        window.status = 'READY'; // This informs wkhtml that the chart is ready
                        checkRoutes();
                    };
                } else {
                    $scope.chartDataObject.callback = function chartDataCallback (chartRequestData) {
                        $scope.newChartData = chartRequestData;
                        $scope.chartData = new CoreChartObject(chartBasics, $scope.newChartData);
                        var custom = (angular.isUndefined(widgetConfig.charts[$scope.graphType].custom) || angular.isUndefined(widgetConfig.charts[$scope.graphType].custom[chartBasics.view])) ? null : widgetConfig.charts[$scope.graphType].custom[chartBasics.view];
                        var customSettings = angular.isUndefined(widgetConfig.charts[$scope.graphType].customSettings) ? null : widgetConfig.charts[$scope.graphType].customSettings;
                        var chartConfig = {
                            view: chartBasics.view,
                            percentageMode: $scope.percentageMode,
                            drillDown: $scope.internalDrillDown,
                            data: $scope.chartData,
                            custom: custom,
                            dataLabels: $scope.labelVisibility,
                            customSettings: customSettings,
                            reportType: ($scope.widgetView === 'report' || $scope.widgetView === 'email') ? $scope.widgetView : 'none'
                        };
                        $scope.chartData = CoreCommon.mergeRecursive($scope.chartData, widgetConfig.charts[$scope.graphType].chart(chartConfig));
                        $scope.widgetIsLoading = false;
                        checkRoutes();
                    };
                }
                //make request and transform results
                $scope.chartDataObject.queryParameters.agents = [];
                $scope.chartDataObject.queryParameters.rssFeeds = [];
                $scope.chartDataObject.queryParameters.tags = [];
                $scope.chartDataObject.queryParameters.dateStart = $scope.chartDataObject.fromDate;
                $scope.chartDataObject.queryParameters.dateEnd = $scope.chartDataObject.toDate;

                if (DashboardStateService.refreshCache) {
                    $scope.chartDataObject.queryParameters.refreshCache = true;
                    DashboardStateService.refreshCache = false;
                }

                ChartDataService.fetchAllData($scope.chartDataObject, $scope.$id).catch(function onCatch(error) {
                    $scope.$emit('chartData_fetchAllDataError', error);
                });

                // Run our updating function when we recieve an update notification from a widget higher in the scope tree.
                $scope.$on('widgetFiltersUpdated', function widgetFiltersUpdated() {
                    $scope.graphType = getDefaultChartTypeFromSettings();
                    $scope.fetchData();
                });
            };

            var checkRoutes = function checkRoutes() {
                if($routeParams.inputId || $routeParams.date) {
                    updateBreadcrumb($routeParams.inputId, $routeParams.date);
                }
            }

        }]);
